import React, { useEffect, useState } from 'react';
import { useId } from 'react-id-generator';
import classes from './ResourceMap.module.scss';
import GoogleMapReact from 'google-map-react';
import Marker from '../GoogleLocation/Marker';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import t from '@/utils/Language/ResourceMap-translations';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const defaultState = {
  mapApiLoaded: false,
  mapInstance: null,
  mapApi: null,
  center: {
    lat: 34.042891,
    lng: -118.251503
  },
  zoom: 9,
  draggable: true
};

const ResourceMap = ({ options, locations, onMarkerClick }, ...props) => {
  const [settings, setSettings] = useState(Object.assign({}, defaultState, options));
  const [transitToggleId] = useId();

  const setState = (state = {}) => {
    setSettings((prevState) => {
      return {
        ...prevState,
        ...state
      };
    });
  };

  // `options` seeds the initial state, so on its own the map would stay on whatever
  // center it first rendered with. Callers re-center by passing a new `options.center`
  // (the resource page does this when the location list re-sorts), so track the
  // coordinates rather than the object — that way a parent re-render with an
  // equivalent center doesn't yank the map back while the member is panning it.
  const centerLat = options?.center?.lat;
  const centerLng = options?.center?.lng;

  useEffect(() => {
    if (centerLat == null || centerLng == null) {
      return;
    }
    setState({ center: { lat: centerLat, lng: centerLng } });
  }, [centerLat, centerLng]);

  const toggleTransitOverlay = (e) => {
    if (e.target.checked) {
      settings.mapTransitLayer.setMap(settings.mapInstance);
    } else {
      settings.mapTransitLayer.setMap(null);
    }
  };

  const changeZoom = (delta) => {
    settings.mapInstance.setZoom(settings.mapInstance.getZoom() + delta);
  };

  const apiHasLoaded = ({ map, maps }) => {
    // TODO: add custom control to map to be able to toggle this on-demand
    const transitLayer = new maps.TransitLayer();
    transitLayer.setMap(map);

    setState({
      mapApiLoaded: true,
      mapInstance: map,
      mapApi: maps,
      mapTransitLayer: transitLayer
    });
  };

  return (
    <div className={classes.resourceMap}>
      {settings.mapApiLoaded === true && (
        <>
          <div className={`${classes.zoomControlContainer} ${classes.customControlContainer}`}>
            <ButtonGroup vertical size="sm" className={`${classes.dropShadow}`}>
              <Button
                variant="light"
                onClick={(e) => {
                  changeZoom(1);
                }}
              >
                <FontAwesomeIcon icon={['fas', 'plus']} />
              </Button>
              <Button
                variant="light"
                onClick={(e) => {
                  changeZoom(-1);
                }}
              >
                <FontAwesomeIcon icon={['fas', 'minus']} />
              </Button>
            </ButtonGroup>
          </div>
          <div className={`${classes.transitToggleContainer} ${classes.customControlContainer} ${classes.dropShadow}`}>
            <Form.Check type="checkbox" id={transitToggleId} defaultChecked={true} label={t('Public Transit')} onChange={toggleTransitOverlay} />
          </div>
        </>
      )}
      <GoogleMapReact
        center={settings.center}
        zoom={settings.zoom}
        draggable={settings.draggable}
        options={{
          fullscreenControl: false,
          zoomControl: false
        }}
        yesIWantToUseGoogleMapApiInternals
        onGoogleApiLoaded={apiHasLoaded}
      >
        {locations && locations.length > 0
          ? locations.map((location, index) => (
              <Marker
                text={location.address}
                useTextbox={true}
                lat={location.lat}
                lng={location.long}
                key={index}
                onClick={() => (onMarkerClick ? onMarkerClick(location) : {})}
              />
            ))
          : null}
      </GoogleMapReact>
    </div>
  );
};

export default ResourceMap;
